export const soonYouWillBeVoteForTravelText = 'PRÓXIMAMENTE PODRÁS VOTAR POR TU DESTINO FAVORITO'
export const travelText = 'Viaje'
